import { useEffect, useState } from 'react';
import { db } from '../../firebaseConfig';
import {
  collection,
  onSnapshot,
  updateDoc,
  doc
} from 'firebase/firestore';
import './index.css';

const ServiceRequestManager = () => {
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, 'serviceRequests'), (snapshot) => {
      setRequests(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
      );
    });

    return () => unsub();
  }, []);

  const handleStatusChange = async (id, currentStatus) => {
    const newStatus = currentStatus === 'pending' ? 'completed' : 'pending';
    await updateDoc(doc(db, 'serviceRequests', id), {
      status: newStatus,
    });
  };

  return (
    <div className="request-manager">
      <h2 className="request-manager-title">Manage Service Requests</h2>
      <table className="request-manager-table">
        <thead>
          <tr>
            <th>Villa</th>
            <th>Service</th>
            <th>Status</th>
            <th>Change Status</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((req) => (
            <tr key={req.id}>
              <td>{req.villaTitle}</td>
              <td>{req.service}</td>
              <td className={`status-${req.status}`}>{req.status}</td>
              <td>
                <button
                  className="status-btn"
                  onClick={() => handleStatusChange(req.id, req.status)}
                >
                  Mark as {req.status === 'pending' ? 'Completed' : 'Pending'}
                </button>
              </td>
            </tr>
          ))}
          {requests.length === 0 && (
            <tr>
              <td colSpan="4">No service requests found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ServiceRequestManager;
